import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê nghỉ phép: ", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Không có thông tin danh sách nghỉ phép. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách nghỉ phép" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Calendar, {
              id: "date",
              modelValue: $setup.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
              selectionMode: "range",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "2000:2100",
              onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendar())),
              onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DataTable, {
              value: $setup.listDayOff,
              paginator: true,
              stripedRows: "",
              rows: 10,
              rowsPerPageOptions: [10,25,50],
              rowHover: true,
              paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
              globalFilterFields: ['hoVaTen','soDienThoai','thoiGian'],
              currentPageReportTemplate: "Có tất cả {totalRecords} lượt nghỉ phép",
              filters: _ctx.filters,
              "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
              style: {"font-size":"13px"}
            }, {
              empty: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "hoVaTen",
                  header: "Họ và tên",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "soDienThoai",
                  header: "Số điện thoại",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "thoiGian",
                  dataType: "date",
                  header: "Thời gian bắt đầu nghỉ",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString(data.ngayTrongTuan) + "," + _toDisplayString($setup.formatDateTime(data.thoiGian)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "soNgay",
                  header: "Số ngày",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "lyDo",
                  header: "Lý do",
                  sortable: ""
                }),
                _createVNode(_component_Column, {
                  field: "xacNhan",
                  header: "Tình trạng",
                  sortable: ""
                }, {
                  body: _withCtx(({data}) => [
                    _createTextVNode(_toDisplayString($setup.status(data.idXacNhan, data.xacNhan)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "nguoiXacNhan",
                  header: "Người xác nhận",
                  sortable: ""
                })
              ]),
              _: 1
            }, 8, ["value", "filters"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}